export class ProductSize {
  id: number
  name: string

  public static from(obj: any): ProductSize {
    return Object.assign(new ProductSize(), obj)
  }
}
